module.exports = __webpack_public_path__ + "static/img/name.29bcdd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/name.png
// module id = V1ST
// module chunks = 1